import React from 'react';
import './SectionList.css';

const SectionList = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="manage-section-list-shell">{children}</div>;
};

export default SectionList;
